<template>
  <div>
    <br >
    <br >
    <br >
    <br >
    <h3 class="text-lg-center">选择城市：</h3>
    <base-button
      v-for="city in allCities"
      class="each-city"
      @click="chooseCity(city)">
      {{ city.name }}
    </base-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  data: function () {
    return {
      allCities: ''
    }
  },

  computed: {
    ...mapState(['user'])
  },
  mounted () {
    this.getAllCities()
  },
  // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
  methods: {
    getAllCities: function () {
      axios.get('/cities/')
        .then(response => {
          this.allCities = response.data
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.$message.error('Unauthorized')
          } else {
            this.$message.error(JSON.stringify(err.response.data.errors))
          }
          this.fetching = false
        })
    },
    chooseCity: function (city) {
      this.$http.defaults.headers.common['city'] = city.id
      axios.defaults.headers.common['city'] = city.id
      this.$router.push('/users')
      localStorage.setItem('city', JSON.stringify(city))
      this.$store.state.city = city
    }
  }
}
</script>
<style>
.each-city {
  display: block !important;
  margin: auto !important;
  margin-bottom: 20px !important;
}
</style>
